import Banner from "@/components/pages/projects/banner";
import Listing from "@/components/pages/projects/lisiting";
import React from "react";
import { getUrqlClient } from "@/lib/urql-client";
import { QUERY_ENDPOINTS } from "@/framework/utils/query-endpoints";
import { sanitize } from "@/framework/utils/sanitize";
// import Clients from "@/components/pages/projects/clients";
import { QUERY_ALL_CLIENTS } from "@/framework/queries/clients";
import Seo from "@/utils/seo";
import { QUERY_PROJECTS_SLIDER } from "@/framework/queries/projects-page-slider";
import dynamic from "next/dynamic";

const Clients = dynamic(() => import("@/components/pages/projects/clients"), {
  ssr: false,
});

export default function Projects({ projectTags, clients, featuredProjects }) {
    const seo = {
        slug: "projects",
        metaTitle: "Your One-Stop Destination for Luxury Interiors - Chalk Studio",
        metaDescription:
            "Interior design services in Gurgaon - Our project includes the super-luxury and premium home interior design ideas for small house India.",
    };

    return (
        <>
            <Seo seo={seo} />
            <Banner featuredProjects={featuredProjects} />
            <Listing projectTags={projectTags} />
            <Clients clients={clients} />
        </>
    );
}

export async function getStaticProps({ params }) {
    const client = await getUrqlClient();
    let projectTags = [];
    let clients = [];
    let featuredProjects = [];

    try {
        projectTags = await client.query(QUERY_ENDPOINTS.GET_PROJECT_TAGS, {
            start: 0,
            limit: 20,
        });
        clients = await client.query(QUERY_ALL_CLIENTS, {
            start: 0,
            limit: 50,
            sort: ["id:asc"],
            filters: {},
        });
        featuredProjects = await client.query(QUERY_PROJECTS_SLIDER, {
            requestPolicy: "network-only",
        });
    } catch (err) {
        console.log("Error fetching data:", err);
    }

    return {
        props: {
            projectTags:
                projectTags?.data?.projectTags?.data?.map((row) => sanitize(row)) ?? [],
            clients: clients?.data?.clients?.data?.map((row) => sanitize(row)) || [],
            featuredProjects:
                featuredProjects?.data?.projectsPageSlider?.data?.attributes?.projects?.data?.map(
                    (row) => sanitize(row)
                ) || [],
        },
        revalidate: 1, // In seconds
    };
}
